export enum FinancialRecordType {
  INCOME = 'INCOME',
  EXPENSE = 'EXPENSE',
}

export interface FinancialRecordRequestDto {
  createdByEmployeeId?: number;
  recordType: FinancialRecordType;
  category?: string;
  amount: number;
  recordDate?: string;
  source?: string;
  description: string;
  referenceNumber?: string;
  relatedTransactionId?: number; // ID giao dịch rút tiền liên quan
}

export interface FinancialRecordResponseDto {
  id: number;
  recordType: FinancialRecordType;
  category?: string;
  amount: number;
  recordDate: string;
  source?: string;
  description: string;
  referenceNumber?: string;
  relatedTransactionId?: number;
  createdBy?: string;
  createdAt?: string;
}

export interface FinancialSummary {
  totalIncome: number;
  totalExpense: number;
  balance: number;
}

export interface CategorySummary {
  category: string;
  amount: number;
  percentage: number;
}
